import { getProgressPercent } from '@/utils/todoHelpers';

interface ProgressBarProps {
  createdAt: Date;
  deadline: Date;
  isOverdrive?: boolean;
  className?: string;
}

export default function ProgressBar({ createdAt, deadline, isOverdrive = false, className = "" }: ProgressBarProps) {
  const progressPercent = getProgressPercent(createdAt, deadline);
  
  // Calculate color based on progress
  let colorClass: string;
  if (isOverdrive) {
    // Purple progression for overdrive tasks
    if (progressPercent <= 25) colorClass = 'bg-overdrive-dark';
    else if (progressPercent <= 50) colorClass = 'bg-overdrive-medium';
    else if (progressPercent <= 75) colorClass = 'bg-overdrive-light';
    else colorClass = 'bg-overdrive-lightest';
  } else {
    // Standard color progression
    if (progressPercent <= 25) colorClass = 'bg-progress-green';
    else if (progressPercent <= 50) colorClass = 'bg-progress-yellow';
    else if (progressPercent <= 75) colorClass = 'bg-progress-orange';
    else colorClass = 'bg-progress-red';
  }
  
  return (
    <div className={`relative w-full h-2 bg-muted rounded-full overflow-hidden ${className}`}>
      {/* Progress fill */}
      <div 
        className={`h-full transition-all duration-300 ease-out ${colorClass}`}
        style={{ width: `${Math.min(progressPercent, 100)}%` }}
      />
      
      {/* Divider lines at 25%, 50%, 75% */}
      {[25, 50, 75].map(threshold => (
        <div
          key={threshold}
          className={`absolute top-0 bottom-0 w-px bg-progress-divider transition-opacity duration-200 ${
            progressPercent >= threshold ? 'opacity-0' : 'opacity-100'
          }`}
          style={{ left: `${threshold}%` }}
        />
      ))}
    </div>
  );
}